// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Box, Card } from '@iheartjane/reefer';
import { spacing } from '@iheartjane/reefer-emotion';

export const BankAccountCard = styled(Card)(({ theme }) => ({
  backgroundColor: theme.colors.grays.ultralight,
  borderRadius: theme.borderRadius.lg,
  ...spacing({ p: 24 }),
}));

export const FakeRadio = styled(Box)<{ selected: boolean }>(
  ({ selected, theme: { colors } }) => ({
    backgroundColor: selected ? colors.primary.main : colors.grays.white,
    border: `2px solid ${selected ? colors.primary.main : colors.grays.mid}`,
    borderRadius: '50%',
    display: 'block',
    div: {
      borderRadius: '50%',
    },
  })
);
